import { render, staticRenderFns } from "./Quit.vue?vue&type=template&id=d805e138&"
import script from "./Quit.vue?vue&type=script&lang=js&"
export * from "./Quit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports